// GraphQL Queries
export const CMS_SERVICE_HERO_QUERY = `hero {
  title
  mobileBreadcrumbColor {
    hex
  }
  titleColor {
    hex
  }
  bodyText
  bodyTextColor {
    hex
  }
  centeredMobileContent
  backgroundColor {
    hex
  }
  image {
    url
    alt
    responsiveImage {
      webpSrcSet
      srcSet
      src
      base64
      aspectRatio
    }
  }
  fullScreenImage
  disclaimer
  disclaimerColor {
    hex
  }
  primaryCta {
    buttonText
    buttonType
    textColor {
      hex
    }
    buttonColor {
      hex
    }
    outline
  }
  secondaryCta {
    buttonText
    buttonType
    textColor {
      hex
    }
    buttonColor {
      hex
    }
    outline
  }
  calculator {
    ... on RemittanceCalculatorRecord {
      __typename
      destinationCurrencyInputLabel
      destinationCurrencyInputPlaceholder
      genericErrorMessage
      id
      partnerDropdownLabel
      partnerDropdownPlaceholder
      sourceCurrencyInputLabel
      transferMethodDropdownLabel
      transferMethodDropdownPlaceholder
      networkFeeLabel
      cta {
        buttonColor {
          hex
        }
        buttonText
        buttonType
        outline
        textColor {
          hex
        }
      }
    }
    ... on CallingCalculatorRecord {
      __typename
      id
      countryDropdownPlaceholder
      countryButtonsLabel
      unlimitedCallingLabel
      genericErrorMessage
      cta {
        buttonColor {
          hex
        }
        buttonText
        outline
        textColor {
          hex
        }
      }
    }
  }
}`

export const CMS_WEB_SIGNUP_FLOW_QUERY = `hero {
    splashTitle
    splashTitleTextColor {
      hex
    }
    splashBodyText
    splashImage {
      url
      alt
    }
    invalidImage {
      alt
      url
    }
    titleInvalid
    bodyTextInvalid
    fullScreenImage
    backgroundColor {
     hex
    }
    modalBackgroundColor {
      hex
    }
  }
  firstStep {
    title
    inputLabel
    termsOfServiceText
    buttonLabel
  }
  secondStep {
    title
    bodyText
    changeNumberButtonLabel
    resendCodeButtonLabel
    buttonLabel
  }
  thirdStep {
    title
    bodyText
    firstNameLabel
    lastNameLabel
    emailLabel
    communityLabel
    marketingConsentText
    buttonLabel
  }
  fourthStep {
    title
    bodyText
    bodyTextMobile
    confirmationImage {
      url
      alt
    }
  }
`

// Temporarily being used for the new hero. Will be removed once the new hero is fully implemented.

export const CMS_SERVICE_HERO_QUERY_CAMPAIGN = `newHero {
  title
  mobileBreadcrumbColor {
    hex
  }
  titleColor {
    hex
  }
  bodyText
  bodyTextColor {
    hex
  }
  centeredMobileContent
  backgroundColor {
    hex
  }
  image {
    url
    alt
    responsiveImage {
      webpSrcSet
      srcSet
      src
      base64
      aspectRatio
    }
  }
  fullScreenImage
  disclaimer
  disclaimerColor {
    hex
  }
  primaryCta {
    buttonText
    buttonType
    textColor {
      hex
    }
    buttonColor {
      hex
    }
    outline
  }
  secondaryCta {
    buttonText
    buttonType
    textColor {
      hex
    }
    buttonColor {
      hex
    }
    outline
  }
}`

export const CMS_DATA_DELETION_QUERY = `
  information
  pageMeta(locale: en) {
    isIndexed
    pageDescription
    pageTitle
    pageBackground {
      hex
    }
  }
  id
  hero {
    ... on CenterAlignedHeroRecord {
      id
      backgroundColor {
        hex
      }
      bodyText
      disclaimer
      title
      titleColor {
        hex
      }
      image {
        url
        alt
      }
    }
  }
  firstStep {
    buttonLabel
    disclaimer
    termsOfServiceText
    title
    inputLabel
  }
  secondStep {
    bodyText
    buttonLabel
    changeNumberButtonLabel
    otpExpiredMessage
    resendCodeButtonLabel
    title
  }
  smsConsentLabel
  dataDeletionText
  genericErrorMessage
  formStep {
    bodyText
    buttonLabel
    title
    cityLabel
    dobLabel
    emailLabel
    firstNameLabel
    lastNameLabel
    zipcodeLabel
    addressLabel
  }
  reviewStep {
    bodyText
    title
    buttonLabel
  }
`
export const CMS_WEB_REFERRAL_FLOW_QUERY = `
hero {
  splashTitle
  splashTitleSignupSuccess
  splashTitleTextColor {
    hex
  }
  splashBodyText
  splashBodyTextSignupSuccess
  invalidImage {
    alt
    url
  }
  titleInvalid
  bodyTextInvalid
  splashImage {
    url
    alt
  }
  fullScreenImage
  backgroundColor {
    hex
  }
  modalBackgroundColor {
    hex
  }
}
firstStep {
  title
  inputLabel
  termsOfServiceText
  buttonLabel
}
secondStep {
  title
  bodyText
  changeNumberButtonLabel
  resendCodeButtonLabel
  buttonLabel
}
thirdStep {
  title
  bodyText
  firstNameLabel
  lastNameLabel
  emailLabel
  communityLabel
  marketingConsentText
  buttonLabel
}
fourthStep {
  title
  bodyText
  bodyTextMobile
  confirmationImage {
    url
    alt
  }
}
pageMeta {
  pageTitle
  pageDescription
}
content {
  type: __typename
  ... on WebCampaignContentBoxStaticImageRecord {
                                isImageFirst
                                isImageRight
                                isImageCentralized
                                image {
                                  url
                                }
                                hasShadow
                                imageClass
                                imageAspectRatio
                                imageIgnoreOptimization
                                video{
                                  url
                                }
                                hasVideoLoop
                                tagline
                                title
                                body
                                ctaAction
                                ctaColor
                                ctaText
                                ctaUrl
                                backgroundColor
                                backgroundAnimation
                              }
  ... on WebCampaignContentBoxFullImageRecord {
                                isImageFirst
                                isImageRight
                                isImageCentralized
                                image {
                                  url
                                }
                                tagline
                                title
                                body
                                ctaAction
                                ctaColor
                                ctaText
                                ctaUrl
                                backgroundColor
                                backgroundAnimation
                                fullHeightImage
                                textColor {
                                  hex
                                }
                                titleColor {
                                  hex
                                }
                              }
  }`
export const PAGE_META = `
pageMeta {
  pageTitle
  pageDescription
  isIndexed
  id
}
`
export const DYNAMIC_CONTENT_QUERY = `
content {
  type: __typename
  ... on WebCampaignContentBoxBarChartRecord {
    isChartFirst
    isChartRight
    isChartCentralized
    chartData
    chartBarColor
    chartBarBackColor
    chartLabelClass
    chartValueClass
    tagline
    title
    body
    ctaAction
    ctaColor
    ctaText
    ctaUrl
    backgroundColor
    backgroundAnimation
    disclaimer
  }
  ... on WebCampaignContentBoxExpandableRecord {
    isImageRight
    image {
      url
    }
    title
    body
    ctaAction
    ctaColor
    ctaText
    ctaUrl
    backgroundColor
  }
  ... on WebCampaignContentBoxFullImageRecord {
    isImageFirst
    isImageRight
    isImageCentralized
    image {
      url
    }
    tagline
    title
    body
    ctaAction
    ctaColor
    ctaText
    ctaUrl
    backgroundColor
    backgroundAnimation
  }
  ... on WebCampaignContentBoxIconCanvaRecord {
    isCanvasFirst
    isCanvasRight
    isCanvasCentralized
    serviceIcon
    serviceLabel
    serviceBackgroundColor
    tagline
    title
    body
    ctaAction
    ctaColor
    ctaText
    ctaUrl
    backgroundColor
    backgroundAnimation
  }
  ... on WebCampaignContentBoxStaticImageRecord {
    isImageFirst
    isImageRight
    isImageCentralized
    image {
      url
    }
    hasShadow
    imageClass
    imageAspectRatio
    imageIgnoreOptimization
    video{
      url
    }
    hasVideoLoop
    tagline
    title
    body
    ctaAction
    ctaColor
    ctaText
    ctaUrl
    backgroundColor
    backgroundAnimation
  }
  ... on WebCampaignContentBoxWithAppScreenRecord {
    isImageFirst
    isImageRight
    isImageCentralized
    appScreenImage {
      url
    }
    appScreenVideo{
      url
    }
    tagline
    title
    body
    ctaAction
    ctaColor
    ctaText
    ctaUrl
    backgroundColor
    backgroundAnimation
  }
  ... on WebCampaignContentBoxWithoutImageRecord {
    tagline
    title
    titleBackgroundColor
    body
    ctaAction
    ctaColor
    ctaText
    ctaUrl
    backgroundColor
    backgroundAnimation
  }

  ... on WebCampaignContentBoxWithHtmlContentRecord {
    isContentFirst
    isContentRight
    isContentCentralized
    htmlContent
    tagline
    title
    body
    ctaAction
    ctaColor
    ctaText
    ctaUrl
    backgroundColor
    backgroundAnimation        
  }
  
  ... on WebCampaignGenericHtmlContentRecord {
    htmlContent       
  }

  ... on WebCampaignFaqRecord {
    title
    faqs
  }
}`

export const CMS_M_PAY_QUERY = `hero {
  title
  mobileBreadcrumbColor {
    hex
  }
  titleColor {
    hex
  }
  bodyText
  bodyTextColor {
    hex
  }
  centeredMobileContent
  backgroundColor {
    hex
  }
  image {
    url
    alt
    responsiveImage {
      webpSrcSet
      srcSet
      src
      base64
      aspectRatio
    }
  }
  fullScreenImage
  disclaimer
  disclaimerColor {
    hex
  }
  primaryCta {
    buttonText
    buttonType
    textColor {
      hex
    }
    buttonColor {
      hex
    }
    outline
  }
  secondaryCta {
    buttonText
    buttonType
    textColor {
      hex
    }
    buttonColor {
      hex
    }
    outline
  }
}
pageContent {
  type: __typename
  ... on WebCampaignContentBoxBarChartRecord {
    id
    backgroundColor
    chartBarBackColor
    chartBarColor
    chartData
    chartLabelClass
    chartValueClass
    ctaAction
    ctaColor
    ctaText
    ctaUrl
    disclaimer
    isChartCentralized
    isChartFirst
    isChartRight
    title
    tagline
  }
  ... on WebCampaignContentBoxFullImageRecord {
    id
    isImageCentralized
    isImageFirst
    isImageRight
    image {
      alt
      url
    }
    backgroundColor
    ctaAction
    ctaColor
    ctaText
    ctaUrl
    fullHeightImage
    title
    body
  }
  ... on WebCampaignContentBoxStaticImageRecord {
    id
    backgroundAnimation
    backgroundColor
    ctaAction
    ctaColor
    ctaText
    ctaUrl
    image {
      alt
      url
    }
    isImageCentralized
    isImageFirst
    isImageRight
    tagline
    title
    body
  }
  ... on WebCampaignContentBoxIconCanvaRecord {
    id
    backgroundColor
    ctaAction
    ctaColor
    ctaText
    ctaUrl
    isCanvasCentralized
    isCanvasFirst
    isCanvasRight
    serviceBackgroundColor
    serviceIcon
    title
    body
  }
  ... on WebCampaignContentBoxWithoutImageRecord {
    id
    backgroundAnimation
    backgroundColor
    body
    ctaAction
    ctaColor
    ctaText
    ctaUrl
    tagline
    title
    titleBackgroundColor
  }

}
isIndexed
ogImage {
  url
}
pageTitle
pageDescription`

export const CMS_TRANSFERLINK_QUERY = `id
information
smsConsentLabel
genericErrorMessage
pageMeta {
  pageTitle
  pageDescription
}
hero {
  fullScreenImage
  id
  splashTitle
  splashBodyText
  disclaimer
  splashTitleTextColor {
    hex
  }
  backgroundColor {
    hex
  }
  splashImage {
    alt
    url
  }
  title
  amountColor {
    hex
  }
  nameColor {
    hex
  }
  bodyTextSuccess
  disclaimer
  modalBackgroundColor {
    hex
  }
  titleSuccess
  exceptionBackgroundColor {
    hex
  }
  messageLabel
  expiryMessage
  buttonLabel
  successBackgroundColor {
    hex
  }
  splashImageSucess {
    alt
    url
  }
  titleCancelled
  titleClaimed
  titleExpired
  titleFailed
  bodyTextCancelled
  bodyTextClaimed
  bodyTextExpired
  bodyTextFailed
  genericExceptionBodyText
  genericExceptionTitle
}
secondStep {
  bodyText
  buttonLabel
  id
  title
  resendCodeButtonLabel
  otpExpiredMessage
}
firstStep {
  title
  termsOfServiceText
  inputLabel
  id
  buttonLabel
  disclaimer
}
formStep {
  bodyText
  buttonLabel
  title
  marketingConsentText
  id
}
reviewStep {
  id
  title
  amountLabel
  buttonLabel
  fromLabel
  bodyText
}
`

export const DIASPORA_START_PAGE_QUERY = `
hero {
  backgroundImage {
    alt
    url
  }
  ctaTitle
  description
  title
  rotatingTitle
  titleColor {
    hex
  }
  rotatingTitleColor {
    hex
  }
  bodyColor {
    hex
  }
  cardBackground {
    hex
  }
  ctaTitleColor {
    hex
  }
  ctaBackgroundColor {
    hex
  }
}
content {
  type: __typename
  ... on AsymmetricContentRecord {
    id
    backgroundTransition
    body
    bodyColor {
      hex
    }
    sectionBackgroundColor {
      hex
    }
    contentBackgroundColor {
      hex
    }
    ctaBackgroundColor {
      hex
    }
    ctaText
    ctaTextColor {
      hex
    }
    ctaOutline
    ctaType
    ctaUrl
    image {
      alt
      url
    }
    imageBackgroundColor {
      hex
    }
    imagePosition
    imagePositionMobile
    hideImageOnMobile
    title
    titleColor {
      hex
    }
  }
  ... on CardCarouselRecord {
    id
    cardCarousel {
      color {
        hex
      }
      image {
        alt
        url
      }
      url
      title
    }
    carouselTitle
    carouselTitleColor {
      hex
    }
    sectionBackgroundColor {
      hex
    }
  }
  ... on CashbackComponentRecord {
    id
    backgroundTransition
    body
    bodyColor {
      hex
    }
    carouselImages {
      gap
      wrap
      size
      sectionBackgroundColor {
        cssRgb
      }
      sectionTitle
      sectionTitleColor {
        hex
      }
      slides {
        alt
        url
      }
    }
    ctaBackgroundColor {
      hex
    }
    ctaText
    ctaTextColor {
      hex
    }
    ctaType
    ctaUrl
    sectionBackgroundColor {
      hex
    }
    title1
    title1Color {
      hex
    }
    title2
    title2Color {
      hex
    }
  }
  ... on ImageCarouselComponentRecord {
    gap
    wrap
    id
    sectionBackgroundColor {
      cssRgb
    }
    sectionTitle
    sectionTitleColor {
      hex
    }
    size
    slides {
      alt
      url
    }
  }
  ... on StandardContentRecord {
    id
    backgroundTransition
    body
    bodyColor {
      hex
    }
    contentAlign
    ctaBackgroundColor {
      hex
    }
    ctaText
    ctaOutline
    ctaTextColor {
      hex
    }
    ctaType
    ctaUrl
    image {
      alt
      url
    }
    imagePosition
    imagePositionMobile
    sectionBackgroundColor {
      hex
    }
    title1
    title1Color {
      hex
    }
    title2
    title2Color {
      hex
    }
    backgroundMedia {
      url
    }
    contentBlend
  }
  ... on WebCampaignMiniCheckoutRecord {
    id
  }
  ... on WebCampaignReviewListRecord {
    id
    rating
    title
    titleColor {
      hex
    }
  }
  ... on ListContentRecord {
    id
    backgroundTransition
    body
    bodyColor {
      hex
    }
    ctaBackgroundColor {
      hex
    }
    ctaText
    ctaOutline
    ctaTextColor {
      hex
    }
    ctaType
    ctaUrl
    image {
      alt
      url
    }
    imagePosition
    imagePositionMobile
    sectionBackgroundColor {
      hex
    }
    title1
    title1Color {
      hex
    }
    title2
    title2Color {
      hex
    }
    fullBleedImage
    graphicImage
  }
}
isIndexed
pageTitle
pageDescription
pageBackground {
  hex
}
alternativeSlugs {
  en
  es
}
`

export const COMMON_SECONDARY_PAGE_QUERY = `
hero {
  backgroundColor {
    hex
  }
  title
  titleColor {
    hex
  }
  bodyText
  bodyTextColor {
    hex
  }
  centeredMobileContent
  disclaimer
  disclaimerColor {
    hex
  }
  fullScreenImage
  image {
    alt
    url
    responsiveImage {
      webpSrcSet
      srcSet
      src
      base64
      aspectRatio
    }
  }
  imageBackgroundColor {
    hex
  }
  primaryCta {
    buttonText
    buttonType
    textColor {
      hex
    }
    buttonColor {
      hex
    }
    outline
  }
  secondaryCta {
    buttonText
    buttonType
    textColor {
      hex
    }
    buttonColor {
      hex
    }
    outline
  }
  calculator {
    ... on RemittanceCalculatorRecord {
      __typename
      destinationCurrencyInputLabel
      destinationCurrencyInputPlaceholder
      genericErrorMessage
      id
      partnerDropdownLabel
      partnerDropdownPlaceholder
      sourceCurrencyInputLabel
      transferMethodDropdownLabel
      transferMethodDropdownPlaceholder
      networkFeeLabel
      estimatedDeliveryLabel
      deliveryTimeNotAvailable
      fewMinutes
      halfHour 
      oneHour
      threeHours
      sixHours
      twelveHours
      oneDay
      fewDays
      cta {
        buttonColor {
          hex
        }
        buttonText
        buttonType
        outline
        textColor {
          hex
        }
      }
    }
    ... on CallingCalculatorRecord {
      __typename
      id
      countryDropdownPlaceholder
      countryButtonsLabel
      unlimitedCallingLabel
      genericErrorMessage
      cta {
        buttonColor {
          hex
        }
        buttonText
        outline
        textColor {
          hex
        }
      }
    }
  }
}
content {
  type: __typename
  ... on ImageCarouselComponentRecord {
    gap
    wrap
    id
    sectionBackgroundColor {
      cssRgb
    }
    sectionTitle
    sectionTitleColor {
      hex
    }
    size
    slides {
      alt
      url
    }
  }  
  ... on StandardContentSecondaryRecord {
    id
    body
    bodyColor {
      hex
    }
    ctaBackgroundColor {
      hex
    }
    ctaOutline
    ctaText
    ctaTextColor {
      hex
    }
    ctaType
    ctaUrl
    fullBleedImage
    graphicImage
    image {
      alt
      url
    }
    imagePosition
    imagePositionMobile
    sectionBackgroundColor {
      hex
    }
    title1
    title1Color {
      hex
    }
    title2
    title2Color {
      hex
    }
  }
  ... on TextOnlySecondaryRecord {
    id
    backgroundMedia {
      url
      alt
    }
    body
    bodyColor {
      hex
    }
    contentBlend
    ctaBackgroundColor {
      hex
    }
    ctaOutline
    ctaText
    ctaTextColor {
      hex
    }
    ctaType
    ctaUrl
    sectionBackgroundColor {
      hex
    }
    title1
    title1Color {
      hex
    }
    title2
    title2Color {
      hex
    }
  }
  ... on WebCampaignMiniCheckoutRecord {
    id
  }
  ... on WebCampaignReviewListRecord {
    id
    rating
    title
    titleColor {
      hex
    }
  }
  ... on WebCampaignFaqRecord {
    title
    faqs
  }
}
isIndexed
pageTitle
pageDescription
pageSchema
pageBackground {
  hex
}
alternativeSlugs {
  en
  es
}
`

export const ADVISORY_PAGE_QUERY = `
isIndexed
pageTitle
pageDescription
pageBackground {
  hex
}
alternativeSlugs {
  en
  es
}
hero {
  bodyColor {
    hex
  }
  ctaTitle
  ctaTitleColor {
    hex
  }
  ctaBackgroundColor {
    hex
  }
  description
  title
  titleColor {
    hex
  }
  cardBackground {
    hex
  }
  backgroundImage {
    alt
    title
    url
    width
    height
  }
  backgroundVerticalAlignment
}
content {
  type: __typename
  ... on StandardContentRecord {
    id
    body
    bodyColor {
      hex
    }
    ctaBackgroundColor {
      hex
    }
    ctaOutline
    ctaText
    ctaTextColor {
      hex
    }
    ctaType
    ctaUrl
    image {
      alt
      url
    }
    imagePosition
    imagePositionMobile
    sectionBackgroundColor {
      hex
    }
    title1
    title1Color {
      hex
    }
    title2
    title2Color {
      hex
    }
  }
  ... on ListContentRecord {
    id
    backgroundTransition
    body
    bodyColor {
      hex
    }
    ctaBackgroundColor {
      hex
    }
    ctaText
    ctaOutline
    ctaTextColor {
      hex
    }
    ctaType
    ctaUrl
    image {
      alt
      url
    }
    imagePosition
    imagePositionMobile
    sectionBackgroundColor {
      hex
    }
    title1
    title1Color {
      hex
    }
    title2
    title2Color {
      hex
    }
    fullBleedImage
    graphicImage
  }
  ... on VideoComponentRecord {
    id
    body
    bodyColor {
      hex
    }
    ctaBackgroundColor {
      hex
    }
    ctaOutline
    ctaText
    ctaTextColor {
      hex
    }
    ctaType
    ctaUrl
    videoPosition
    videoPositionMobile
    sectionBackgroundColor {
      hex
    }
    title1
    title1Color {
      hex
    }
    title2
    title2Color {
      hex
    }
    contentAlign
    isFullWidth
    uploadedVideo {
      title
      url
    }
    embeddedVideo {
      height
      title
      url
      providerUid
      width
    }
  }
  ... on VideoCarouselComponentRecord {
    id
    sectionBackgroundColor {
      hex
    }
    body
    bodyColor {
      hex
    }
    title
    titleColor {
      hex
    }
    videoCarousel {
      name
      title
      thumbnail {
        url
        alt
      }
      video {
        url
        video {
          mp4Url(res: medium)
          streamingUrl
        }
      }
    }
    noVideoSupportText
  }
  ... on WebCampaignFaqRecord {
    title
    faqs
  }
  ... on MiniCheckoutComponentRecord {
    id
    body
    bodyColor {
      hex
    }
    ctaBackgroundColor {
      hex
    }
    ctaOutline
    ctaText
    ctaTextColor {
      hex
    }
    ctaType
    ctaUrl
    sectionBackgroundColor {
      hex
    }
    disclaimer
    disclaimerColor {
      hex
    }
    sectionBackgroundImage {
      height
      url
      width
    }
    mobileBackgroundImage {
      url
      responsiveImage {
        alt
        height
        src
        width
      }
    }
    title1
    title1Color {
      hex
    }
    title2
    title2Color {
      hex
    }
    contentAlign
    appStoreLink
    appStoreBadge {
      alt
      url
      width
      height
    }
    googlePlayLink
    googlePlayBadge {
      alt
      url
      width
      height
    }
  }
}`

export const HELP_PAGE_QUERY = `
pageMeta {
  isIndexed
  pageDescription
  pageTitle
  pageBackground {
    hex
  }
}
hero {
  title
  titleColor {
    hex
  }
  backgroundColor {
    hex
  }
  bodyText
  bodyTextColor {
    hex
  }
  centeredMobileContent
  disclaimer
  disclaimerColor {
    hex
  }
  fullScreenImage
  image {
    alt
    filename
    title
    url
  }
  searchBlock {
    placeholderText
    searchIcon {
      url
    }
  }
}
content {
  ... on HelpArticleListRecord  {
    __typename
    listTitle
    articleIdsList
    numberOfItems
  }
  ... on HelpCategoriesListRecord {
    __typename
    sectionBackgroundColor {
      hex
    }
    title
    titleColor {
      hex
    }
  }
  ... on HelpWatchAndLearnListRecord {
    __typename
    sectionBackgroundColor {
      hex
    }
    title
    titleColor {
      hex
    }
    listLabel
    noVideosText
    videos {
      id
      title
      video {
        url
        providerUid
        title
      }
      duration
    }
  }
  ... on HelpContactUsSectionRecord {
    __typename
    sectionBackgroundColor {
      hex
    }
    title
    titleColor {
      hex
    }
    bodyText
    bodyTextColor {
      hex
    }
    contactItems {
      title
      ctaText
      ctaActionInfo
      contactType
      body
    }
  }
  ... on SearchPageCopyRecord {
    __typename
    articlesFound
    articlesNotFound
    loadMore
    loading
  }
}`

export const LOCATIONS_PAGE_QUERY = `
hero {
  backgroundColor {
    hex
  }
  bodyText
  bodyTextColor {
    hex
  }
  centeredMobileContent
  disclaimer
  disclaimerColor {
    hex
  }
  fullScreenImage
  image {
    url
  }
  imageBackgroundColor {
    hex
  }
  mobileBreadcrumbColor {
    hex
  }
  primaryCta {
    buttonColor {
      hex
    }
    buttonText
    buttonType
    outline
    textColor {
      hex
    }
  }
  secondaryCta {
    buttonColor {
      hex
    }
    buttonText
    buttonType
    outline
    textColor {
      hex
    }
  }
  showCalculator
  title
  titleColor {
    hex
  }
}
content {
  ... on LocationItemRecord {
    __typename
    address
    city
    createdAt
    directionsCtaText
    directionsUrl
    images {
      alt
      url
    }
    locationType
    openingHours
    state
  }
  ... on StandardContentSecondaryRecord {
    __typename
    body
    bodyColor {
      hex
    }
    ctaBackgroundColor {
      hex
    }
    ctaOutline
    ctaText
    ctaTextColor {
      hex
    }
    ctaType
    ctaUrl
    fullBleedImage
    graphicImage
    image {
      alt
      url
    }
    imagePosition
    imagePositionMobile
    sectionBackgroundColor {
      hex
    }
    title1
    title1Color {
      hex
    }
    title2
    title2Color {
      hex
    }
  }
}
isIndexed
pageTitle
pageDescription
pageSchema
pageBackground {
  hex
}
alternativeSlugs {
  en
  es
}`
